import { render, staticRenderFns } from "./SavedCardToPlainFieldsSwitch.vue?vue&type=template&id=5a4c0bd6&"
import script from "./SavedCardToPlainFieldsSwitch.vue?vue&type=script&lang=js&"
export * from "./SavedCardToPlainFieldsSwitch.vue?vue&type=script&lang=js&"
import style0 from "./SavedCardToPlainFieldsSwitch.vue?vue&type=style&index=0&id=5a4c0bd6&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports